<section class="answer-questions-section container-fluid sts-section">

  <app-sts-section-header key="sts-answer-questions-header" [errors]="errors">Answer
    security questions
  </app-sts-section-header>

  <app-sts-section-body key="sts-answer-questions-body" *ngIf="hasQuestions && !tooManyInvalidResponses">
    Please answer your security
    questions and select <span class="bold">Next.</span>
  </app-sts-section-body>


  <form (ngSubmit)="onSubmit()" class="sts-form" autocomplete="off">

        <div class="row">
          <div app-sts-cms-txt class="col-8" key="sts-no-questions-to-answer"
               *ngIf="noQuestionsFound">
            Sorry this option is not available at the moment.
          </div>
        </div>

        <ng-container *ngIf="!tooManyInvalidResponses">
          <div class="row sts-input-row" *ngFor="let qAndA of currentQAndA; let i = index;">

            <div class="col-8 question-container">
              {{ isFrench() ? qAndA.question.textFr : qAndA.question.textEn }}
            </div>

            <div class="col-16" *ngIf="hasQuestions">
              <input type="input" class="sts-textbox " id="password"
                     [disabled]="!hasQuestions"
                     [ngClass]="{'disabled': !hasQuestions}"
                     [(ngModel)]="qAndA.answer"
                     (keyup)="answerChanged($event, i)"
                     name="answer">
              <app-sts-show-error key="sts-field-error-answer-required"
                                  description="Answer is required"
                                  [show]="!isAnswerValid(i) && answerDirtyFlags[i]">
              </app-sts-show-error>
            </div>
          </div>
        </ng-container>

        <div class="row">
          <div class="col-24">

            <button type="button" app-sts-cms-txt key="sts-cancel-button"
            *ngIf="noQuestionsFound || hasQuestions" class="sts-btn other-sts-btn" (click)="onContinue()">
              Cancel
            </button>


            <button type="button" class="sts-btn other-sts-btn" app-sts-cms-txt
                    (click)="switchToEmail()"
                    key="sts-send-email-switch-button"
                    *ngIf="isPasswordRecoveryEmailSupported && tooManyInvalidResponses"
                    [ngClass]="{'disabled': !isPasswordRecoveryEmailSupported }">Send Me An Email Instead</button>

            <app-sts-button key="sts-next-button" [disabled]="!isEntirelyValid()"
                  [hidden]="!(hasQuestions && isDuring)" >
              Next
            </app-sts-button>

          </div>
        </div>

  </form>




</section>
